import { View, Text, Image } from "@react-pdf/renderer";
import styles from "./styles";
import FaNum from "./FaNum";
import moment from "moment";

export default function ProductTable({ products }) {
  return (
    <View style={styles.productsBox}>
      <View style={styles.tableHeaderRow}>
        <Text style={styles.th}>#</Text>
        <Text style={[styles.th, { flex: 5 }]}>نام محصول</Text>
        <Text style={styles.th}>تعداد</Text>
        <Text style={styles.th}>قیمت واحد</Text>
        <Text style={styles.th}>تخفیف</Text>
        <Text style={styles.th}>جمع</Text>
      </View>

      {products.map((product, index) => {
        const unitPrice = Number(product.price || product.priceSale || 0);
        const salePrice = Number(product.priceSale || unitPrice);
        const discountRow = (unitPrice - salePrice) * product.quantity;
        const totalRow = salePrice * product.quantity;

        return (
          <View key={product.id} style={styles.tableBodyRow}>
            {/* Row Number */}
            <View style={styles.td}>
              <View style={styles.rowNumberCircle}>
                <FaNum>{index + 1}</FaNum>
              </View>
            </View>

            {/* Product Name */}
            <View style={styles.tdName}>
              <View style={styles.productNameMain}>
                <Text style={{ fontFamily: "BYekan" }}>
                  {product.name}
                  {product.attribute && <Text>({product.attribute})</Text>}
                </Text>
              </View>

              {product.expire && (
                <Text style={styles.expireText}>
                  تاریخ انقضا: {moment(product.expire).format("DD-MM-YYYY")}
                </Text>
              )}

              {product.giftName && (
                <Text style={styles.giftText}>
                  هدیه خرید: {product.giftName}
                  <Image src="/images/icons/gift.png" style={styles.giftIcon} />
                </Text>
              )}
            </View>

            {/* Quantity */}
            <View style={styles.td}>
              <View style={styles.tdInner}>
                <FaNum>{product.quantity}</FaNum>
              </View>
            </View>

            {/* Unit Price */}
            <View style={styles.td}>
              <View style={styles.tdInner}>
                <FaNum>{unitPrice}</FaNum>
              </View>
            </View>

            {/* Discount */}
            <View style={styles.td}>
              <View style={styles.tdInner}>
                <FaNum>{discountRow}</FaNum>
              </View>
            </View>

            {/* Total */}
            <View style={styles.td}>
              <View style={styles.tdInner}>
                <FaNum>{totalRow}</FaNum>
              </View>
            </View>
          </View>
        );
      })}
    </View>
  );
}
